import { Card, Button, Table, Space, Image } from "antd";
import { EditOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { complianceType } from "../../constant";

const Compliance = () => {
  const navigate = useNavigate();

  const columns = [
    {
      title: "#",
      dataIndex: "key",
      render: (text, record, index) => index + 1,
      width: "5%",
    },
    {
      title: "Title",
      dataIndex: "title",
      render: (text) => <span>{text}</span>,
    },
    {
      title: "Image",
      dataIndex: "image_path",
      render: (text) => (
        <Image
          width={200}
          src={text}
          alt="Uploaded compliance image"
          style={{
            objectFit: "cover",
            border: "1px solid #d9d9d9",
            borderRadius: "6px",
          }}
        />
      ),
    },
    {
      title: "Action",
      key: "action",
      render: (text, record) => (
        <Space size="middle">
          <Button
            type="primary"
            icon={<EditOutlined />}
            size="small"
            onClick={() => navigate(`/compliance/create/${record.value}`)}
          >
            Edit
          </Button>
        </Space>
      ),
      width: "15%",
    },
  ];

  return (
    <Card title="Compliance List" style={{ fontSize: "20px" }} bordered={false}>
      <Table columns={columns} dataSource={complianceType} rowKey="key" />
    </Card>
  );
};

export default Compliance;
